<template>
  <div>系统通知</div>
</template>

<script>
export default {

}
</script>

<style>

</style>